var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"banner_default_box"},[_c('div',{staticClass:"box_title"},[_vm._v(_vm._s(_vm.defaultContentTitle))]),_c('div',{staticClass:"box_content"},_vm._l((_vm.defaultContentList),function(item,index){return _c('div',{key:index,staticClass:"content_item"},[_vm._v(_vm._s(item))])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }